module.exports = require("lodash/startCase");